import React, { useEffect, useMemo, useRef, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import ShipDateDropdown from '../../sharedComponents/ShipDateDropdown';
import ProfileCombo from '../../sharedComponents/ProfileCombo';
import useManageWeeklyShip from '../weeklyShip/useManageWeeklyShip';
import useGetCustomerProfile from '../../hooks/useGetCustomerProfile';
import useManageOrder from '../order/useManageOrder';
import ImageModal from './ImageModel';
import { formatDate } from '../../utils/dateUtils';
import { getAirItemTypeLabel } from '../../utils/airItemTypeUtils';
import AirItemTypeInputs from '../../sharedComponents/AirItemTypeInputs';
import { toast } from 'react-toastify';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import PersonIcon from '@mui/icons-material/Person';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { PlusIcon, TrashIcon } from '@heroicons/react/24/solid';
import handCarryService from '../handCarry/handCarryService';
import AirItemTypeService from '../setting/airItemType/AirItemTypeService';
import AirItemTypeTripleDropdown from '../../sharedComponents/AirItemTypeTripleDropdown';
import HeldItemsModal from '../util/trackingLookup/HeldItemsModal';
import useShipDate from '../setting/shipDate/useShipDate';
import GetCustomerProfileService from '../../services/GetCustomerProfileService';

const WeeklyShipMatch = () => {

  const ImageRenderer = ({ value} ) => (
    <div style={{ cursor: 'pointer' }} onClick={() => openModal(value)}>
      <img src={value} alt="Thumbnail" style={{ height: '150px', width: 'auto' }} />
    </div>
  );

  // Unpacked-contents photo (many boxes won't have one) — render nothing when absent.
  const UnpackImageRenderer = ({ value }) => (
    value ? (
      <div style={{ cursor: 'pointer' }} onClick={() => openModal(value)}>
        <img src={value} alt="Unpack" style={{ height: '150px', width: 'auto' }} />
      </div>
    ) : null
  );

  const LinkRenderer = ({value}) => (
      <a 
        href={value} 
        target="_blank" 
        rel="noopener noreferrer"
        style={{ color: 'blue', textDecoration: 'underline' }}
      >
        Link
      </a>
    );

  const columnDefs = [
    {
      headerCheckboxSelection: false,
      checkboxSelection: true,
      width: 50,
      sortable: false
    },
    { headerName: 'Box Name', field: 'boxName', flex: 1 },
    { headerName: 'Tracking No.', field: 'trackingJp', flex: 1 },
    { headerName: 'Image', field: 'shipImageUrl', cellRenderer: ImageRenderer },
    { headerName: 'Unpack', field: 'unpackImageUrl', cellRenderer: UnpackImageRenderer },
    { headerName: 'Weight', field: 'weight', flex: 1 },
    { headerName: 'Box No.', field: 'boxNo', flex: 1 },
    { headerName: 'Ship Date', field: 'shipDate', flex: 1 },
  ];

  const MercariVerifyRenderer = ({ value }) => {
    if (!value || value === 'pending') return null;
    if (value === 'not_approved') return (
      <span style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        background: '#fee2e2', color: '#b91c1c',
        borderRadius: 4, padding: '2px 6px', fontSize: 11, fontWeight: 600
      }}>
        ⚠️ ไม่อนุมัติ
      </span>
    );
    if (value === 'approved') return (
      <span style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        background: '#dcfce7', color: '#15803d',
        borderRadius: 4, padding: '2px 6px', fontSize: 11, fontWeight: 600
      }}>
        ✓ อนุมัติ
      </span>
    );
    return null;
  };

  const columnDefs2 = [
    {
      headerCheckboxSelection: false,
      checkboxSelection: true,
      width: 50,
      sortable: false
    },  
    { headerName: 'Order Date', field: 'orderDate' , flex: 1},
    { headerName: 'Smile Name', field: 'smileNameInput' , flex: 1},
    { headerName: 'Link', field: 'url', cellRenderer: LinkRenderer, flex: 1 },
    { headerName: 'Tracking', field: 'trackingJp' , flex: 1},
    { headerName: 'รอบเรือ', field: 'shipDate' , flex: 1},
    { headerName: 'Mercari', field: 'mercariVerifyStatus', cellRenderer: MercariVerifyRenderer, width: 120 },
  ] ;

  const hightlightMatchStyle = {
    backgroundColor: '#fff9b8', // Light blue background for highlighted rows
  };

  const highlightedUnboxStyle = {
    backgroundColor: '#9bdafa', // Light blue background for highlighted rows
  };

  const [showHighlightedRows, setShowHighlightedRows] = useState(true);
  const [weeklyShipKeys, setWeeklyShipKeys] = useState([]);
  const [profileNameState, setProfileNameState] = useState('')
  const [allOrder, setAllOrder] = useState(false)

  const [orderKeys, setOrderKeys] = useState([]);
  const [rowData, setRowData] = useState([]);
  //const [filteredRowData, setFilteredRowData] = useState([]);
  const [rowData2, setRowData2] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [shipDateId, setShipDateId] = useState('');
  const [shipDate, setShipDate] = useState('');
  const [modalImageSrc, setModalImageSrc] = useState('');
  const [weeklyShipRowIndexes, setWeeklyShipRowIndexes] = useState(0);
  const [profileRowIndex, setProfileRowIndex] = useState(0);
  const [searchText, setSearchText] = useState('')
  const [selectedProfile, setSelectedProfile] = useState(null)
  const [selectedShipDate, setSelectedShipDate] = useState(null)
  const [showQuantityModal, setShowQuantityModal] = useState(false)
  const [ordersNeedingQuantity, setOrdersNeedingQuantity] = useState([])
  const [quantities, setQuantities] = useState({})
  const [perKgWeights, setPerKgWeights] = useState({}) // { handCarryAirItemId: kg } for each per_kg assignment
  const [pendingMatchData, setPendingMatchData] = useState(null)
  const gridRef = useRef()
  const gridRef2 = useRef()

  // Combined fix-order dialog (handles both "not handCarry" and "no air item type" in one pass)
  const [showFixOrderDialog, setShowFixOrderDialog] = useState(false)
  const [fixOrderItems, setFixOrderItems] = useState([])   // each item has needsHandCarry: bool
  const [airItemTypesList, setAirItemTypesList] = useState([])
  const [airTypeAssignments, setAirTypeAssignments] = useState({})
  const [savingFixOrderId, setSavingFixOrderId] = useState(null)

  const [gridOptions, setGridOptions] = useState({
    rowSelection: 'multiple',
  });
  const [gridOptions2, setGridOptions2] = useState({
    rowSelection: 'multiple',
  });


  const {shipDates, setShipDates, isLoading,
    getUnmatchItemByShipDate,
    matchWeeklyShipAndOrder,
    cancelWeeklyShipOrderMatch,
    awaitUnboxWeeklyShip
  } = useManageWeeklyShip()

  const {profiles,
    getCustomerProfiles,
  } = useGetCustomerProfile()

  // Held-items (ON-HOLD) modal — same list TrackingLookup opens, so admins can see
  // pending parcels from here too. Its data (all-shop profiles for Find Order + ship
  // dates with warehouse address for the round dropdown) is fetched lazily on first
  // open; the page's own shop-scoped profiles/rounds aren't reused on purpose.
  const [heldModalOpen, setHeldModalOpen] = useState(false);
  const [heldProfiles, setHeldProfiles] = useState([]);
  const [heldProfilesReady, setHeldProfilesReady] = useState(false);
  const { shipDates: heldShipDates, getShipDates: getHeldShipDates } = useShipDate();

  const openHeldModal = () => {
    if (!heldProfilesReady) {
      GetCustomerProfileService.getCustomerProfiles(undefined)
        .then((r) => { setHeldProfiles(r.data); setHeldProfilesReady(true); })
        .catch(() => setHeldProfilesReady(true));
    }
    if (!heldShipDates.length) getHeldShipDates();
    setHeldModalOpen(true);
  };

  const handleInputChange = (e) => {
    setSearchText(e.target.value)
  }

  const {orders, setOrders, getLatestOrder,
    getOrdersFromSmileName
  } = useManageOrder()


  useEffect(()=>{
    console.log(selectedShipDate)
  },[selectedShipDate])

  const handleSelectChange = (e) => {
    setShipDateId(e.target.value)
    const selectedIndex = e.target.selectedIndex;
    const selectedOptionText = e.target.options[selectedIndex].text;
    setShipDate(selectedOptionText);
    
    // Detect if it's Air by checking if the option text contains "เครื่องบิน"
    const isAir = selectedOptionText.includes('เครื่องบิน');
    console.log('Selected option text:', selectedOptionText);
    console.log('Is Air detected:', isAir);
    
    // Create a mock shipDate object with isAir property
    const selectedShipDateObj = {
      id: e.target.value,
      isAir: isAir
    };
    setSelectedShipDate(selectedShipDateObj);
  }

  const handleWeeklyShipSelection = () => {
    const selectedNodes = gridOptions.api.getSelectedNodes();
    const keys = selectedNodes.map(node => node.data.uuid);
    setWeeklyShipKeys(keys);  // Setting the state
    if (selectedNodes.length > 0) {
      setWeeklyShipRowIndexes(selectedNodes[0].rowIndex);
    }
  }

  const handleOrderSelection = () => {
    const selectedNodes = gridOptions2.api.getSelectedNodes();
    const keys = selectedNodes.map(node => node.data.uuid);
    setOrderKeys(keys);  // Setting the state
    if (selectedNodes.length > 0) {
      setProfileRowIndex(selectedNodes[0].rowIndex)
    }
  }

  const handleProfileSelect = async (smileName) => {
    setProfileNameState(smileName)
    const profile = profiles.find(p => p.smileName === smileName);
    setSelectedProfile(profile);
    const orderData = await getOrdersFromSmileName({smileName,weeklyMatchAllOrder: allOrder})
  }

  const handleOpenCustomerProfile = () => {
    if (selectedProfile && selectedProfile.smileName) {
      const url = `/customer-profile?smileName=${encodeURIComponent(selectedProfile.smileName)}`;
      window.open(url, '_blank');
    } else {
      toast.warning("กรุณาเลือกลูกค้าก่อน");
    }
  }

  const handleQuantityChange = (key, value) => {
    if (/^[0-9]*$/.test(value)) {
      setQuantities(prev => ({
        ...prev,
        [key]: value
      }));
    }
  }

  const handlePerKgWeightChange = (handCarryAirItemId, value) => {
    const normalized = value === '' || value === undefined ? '' : String(value).replace(/[^0-9.]/g, '');
    if (normalized === '' || /^\d*\.?\d*$/.test(normalized)) {
      setPerKgWeights(prev => ({
        ...prev,
        [handCarryAirItemId]: normalized
      }));
    }
  }

  const handleQuantityModalClose = () => {
    setShowQuantityModal(false);
    setOrdersNeedingQuantity([]);
    setQuantities({});
    setPerKgWeights({});
    setPendingMatchData(null);
  }

  // DRY function to handle matching response
  const handleMatchingResponse = (response, weeklyShipKeys, orderKeys) => {
    if (response) {
      const updatedWeeklyShips = shipDates.map(weeklyShip => ({
        ...weeklyShip,
        hasOrders: weeklyShipKeys.includes(weeklyShip.uuid) ? true : weeklyShip.hasOrders || false
      }));
      setShipDates(updatedWeeklyShips);
    
      const updatedOrders = orders.filter(order => !orderKeys.includes(order.uuid));
      setOrders(updatedOrders);

      toast.success("อัพเดทข้อมูลสำเร็จ")
      setWeeklyShipKeys([])
      setOrderKeys([])
    } else if (response === null) {
      // e.g. a box and an order from different shops on a sea round
      toast.error("ไม่พบข้อมูล กรุณาตรวจสอบกล่องและออเดอร์ที่เลือก (ต้องเป็นร้านเดียวกัน)")
    } else {
      toast.error("มีบางอย่างผิดพลาด")
    }
  }

  const handleQuantitySubmit = async () => {
    // Validate: per-type or legacy single quantity per order
    const hasPerTypeInputs = ordersNeedingQuantity.some(o => o.perItemAirItems?.length > 0);
    let missingCount = 0;
    let missingLabels = [];
    if (hasPerTypeInputs) {
      ordersNeedingQuantity.forEach(order => {
        order.perItemAirItems?.forEach(ai => {
          if (!quantities[ai.id] || quantities[ai.id] === '') {
            missingCount++;
            if (missingLabels.length < 3) {
              missingLabels.push(`${order.contact} - ${getAirItemTypeLabel(ai.airItemType)}`);
            }
          }
        });
      });
    } else {
      const missing = ordersNeedingQuantity.filter(order => !quantities[order.id]);
      missingCount = missing.length;
      missingLabels = missing.slice(0, 3).map(o => o.contact);
    }
    if (missingCount > 0) {
      toast.warning(`กรุณาใส่จำนวนสำหรับ: ${missingLabels.join(', ')}${missingCount > 3 ? ' ...' : ''}`);
      return;
    }
    const allPerKgAirItems = ordersNeedingQuantity.flatMap(o => (o.handCarry?.airItems || []).filter(ai => ai.airItemType?.calculationMethod === 'per_kg'));
    if (allPerKgAirItems.length > 0) {
      const missingKg = allPerKgAirItems.filter(ai => !perKgWeights[ai.id] || perKgWeights[ai.id] === '' || Number.isNaN(parseFloat(perKgWeights[ai.id])));
      if (missingKg.length > 0) {
        const firstLabel = getAirItemTypeLabel(missingKg[0].airItemType);
        toast.warning(`กรุณาใส่น้ำหนัก (kg) สำหรับรายการต่อกิโล: ${firstLabel}${missingKg.length > 1 ? ' ...' : ''}`);
        return;
      }
    }

    const itemsPerAssignment = {};
    const itemsPerPurchase = {};
    ordersNeedingQuantity.forEach(order => {
      if (order.perItemAirItems?.length > 0) {
        order.perItemAirItems.forEach(ai => {
          if (quantities[ai.id]) {
            itemsPerAssignment[ai.id] = parseInt(quantities[ai.id], 10);
          }
        });
      } else {
        if (quantities[order.id]) {
          itemsPerPurchase[order.id] = parseInt(quantities[order.id], 10);
        }
      }
    });

    if (pendingMatchData) {
      const payload = { ...pendingMatchData };
      if (Object.keys(itemsPerAssignment).length > 0) {
        payload.itemsPerAssignment = itemsPerAssignment;
      }
      if (Object.keys(itemsPerPurchase).length > 0) {
        payload.itemsPerPurchase = itemsPerPurchase;
      }
      const allPerKgAirItems = ordersNeedingQuantity.flatMap(o => (o.handCarry?.airItems || []).filter(ai => ai.airItemType?.calculationMethod === 'per_kg'));
      if (allPerKgAirItems.length > 0) {
        const weights = {};
        allPerKgAirItems.forEach(ai => {
          const w = perKgWeights[ai.id];
          if (w !== '' && w !== undefined && !Number.isNaN(parseFloat(w))) {
            weights[ai.id] = parseFloat(w);
          }
        });
        if (Object.keys(weights).length > 0) payload.perKgWeights = weights;
      }
      const response = await matchWeeklyShipAndOrder(payload);
      handleMatchingResponse(response, pendingMatchData.weeklyShipKeys, pendingMatchData.orderKeys);
    }

    handleQuantityModalClose();
  }

  const toggleAllOrder = async () => {
    if(profileNameState){
      await getOrdersFromSmileName({smileName:profileNameState,weeklyMatchAllOrder:!allOrder})
    }
    setAllOrder(!allOrder)
  }

  const handleToggleHighlight = () => {
    setShowHighlightedRows((prevState) => !prevState);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const response = await getLatestOrder({ searchText: searchText })
    if(!response){
      toast.error("มีบางอย่างผิดพลาด")
    }
  }  

  // Function to fetch detailed order information
  const fetchOrderDetails = async (orderIds) => {
    try {
      const selectedOrders = orders.filter(order => orderIds.includes(order.uuid));
      
      // Map the actual order structure to include handCarry details
      // Use airItems (HandCarryAirItem) when available; fallback to legacy airItemType
      const ordersWithDetails = selectedOrders.map(order => {
        const handCarry = order.handCarry;
        const airItems = handCarry?.airItems || [];
        const hasAssignedItems = airItems.length > 0;
        
        let calculationMethod = "per_kg";
        let assignedPerItemQty = 0;
        const perItemAirItems = []; // HandCarryAirItem entries with per_item type
        
        if (hasAssignedItems) {
          const perItemList = airItems.filter(ai => ai.airItemType?.calculationMethod === 'per_item');
          if (perItemList.length > 0) {
            calculationMethod = "per_item";
            assignedPerItemQty = perItemList.reduce((sum, ai) => sum + (ai.qty || 1), 0);
            perItemAirItems.push(...perItemList);
          }
        }
        // Else: no airItems → no calculation method (legacy single airItemType on HandCarryList deprecated)

        return {
          ...order,
          isHandCarry: !!handCarry,
          calculationMethod,
          assignedPerItemQty,
          perItemAirItems
        };
      });
      
      return ordersWithDetails;
    } catch (error) {
      console.error('Error fetching order details:', error);
      return [];
    }
  };

  // ── Combined fix-order helpers ─────────────────────────────────────────────
  const handleOpenFixOrderDialog = async (nonHandCarryOrders, ordersWithoutType) => {
    let types = airItemTypesList
    if (types.length === 0) {
      try {
        const res = await AirItemTypeService.getAirItemTypes({ isActive: true })
        types = res.data?.data || []
        setAirItemTypesList(types)
      } catch (e) {
        toast.error('ไม่สามารถโหลดประเภทสินค้าหิ้วได้')
        return
      }
    }
    // Combine: non-handCarry first (need register + assign), then handCarry-but-no-type (assign only)
    const combined = [
      ...nonHandCarryOrders.map(o => ({ ...o, needsHandCarry: true })),
      ...ordersWithoutType.map(o => ({ ...o, needsHandCarry: false })),
    ]
    const initial = {}
    combined.forEach(o => {
      const existing = o.handCarry?.airItems || []
      initial[o.id] = existing.length > 0
        ? existing.map(ai => ({ airItemTypeId: ai.airItemTypeId, qty: ai.qty || 1 }))
        : [{ airItemTypeId: '', qty: 1 }]
    })
    setAirTypeAssignments(initial)
    setFixOrderItems(combined)
    setShowFixOrderDialog(true)
  }

  const handleCloseFixOrderDialog = () => {
    setShowFixOrderDialog(false)
    setFixOrderItems([])
    setAirTypeAssignments({})
  }

  const handleAirTypeAssignmentChange = (orderId, index, field, value) => {
    setAirTypeAssignments(prev => ({
      ...prev,
      [orderId]: prev[orderId].map((row, i) => i === index ? { ...row, [field]: value } : row)
    }))
  }

  const handleAddAirTypeRow = (orderId) => {
    setAirTypeAssignments(prev => ({
      ...prev,
      [orderId]: [...(prev[orderId] || []), { airItemTypeId: '', qty: 1 }]
    }))
  }

  const handleRemoveAirTypeRow = (orderId, index) => {
    setAirTypeAssignments(prev => ({
      ...prev,
      [orderId]: prev[orderId].filter((_, i) => i !== index)
    }))
  }

  // Saves one order: optionally registers handCarry first, then assigns air item type
  const handleSaveFixOrder = async (order) => {
    const customerId = selectedProfile?.id || order.CustomerProfile?.id || order.customerId;
    if (!customerId) {
      toast.warning('กรุณาเลือกลูกค้าก่อน')
      return
    }
    const rows = airTypeAssignments[order.id] || []
    const validRows = rows.filter(r => r.airItemTypeId)
    if (validRows.length === 0) {
      toast.warning('กรุณาเลือกอย่างน้อย 1 ประเภท')
      return
    }
    setSavingFixOrderId(order.id)
    try {
      let existingHandCarryId = order.handCarry?.id

      // Step 1 (if needed): register as handCarry
      if (order.needsHandCarry) {
        const regRes = await handCarryService.registerHandCarryList({
          url: order.url,
          customerId: customerId,
          orderId: order.id
        })
        existingHandCarryId = regRes.data.id
      }

      // Step 2: assign air item types
      const items = validRows.map(r => {
        const type = airItemTypesList.find(t => t.id === r.airItemTypeId)
        return {
          airItemTypeId: r.airItemTypeId,
          qty: type?.calculationMethod === 'per_item' ? (r.qty || 1) : 1
        }
      })
      const assignRes = await handCarryService.assignTypesToHandCarryByOrderId(order.id, items)
      const newAirItems = assignRes.data?.data || []

      setOrders(prev => prev.map(o =>
        o.id === order.id
          ? { ...o, handCarry: { id: existingHandCarryId, ...(o.handCarry || {}), airItems: newAirItems } }
          : o
      ))
      setFixOrderItems(prev => prev.filter(o => o.id !== order.id))
      toast.success(`บันทึกสำเร็จ: ${order.contact || order.smileNameInput}`)
    } catch (e) {
      toast.error(`ไม่สามารถบันทึก: ${e?.response?.data?.message || e.message}`)
    }
    setSavingFixOrderId(null)
  }

  const handleMatchClick = async () => {
    console.log(weeklyShipKeys)
    if(weeklyShipKeys.length > 0){
      if(orderKeys.length > 0){
        // Check if selected shipDate is Air and validate handCarry orders
        console.log('selectedShipDate:', selectedShipDate);
        console.log('selectedShipDate.isAir:', selectedShipDate?.isAir);
        if(selectedShipDate && selectedShipDate.isAir) {
          // Fetch detailed order information
          const selectedOrders = await fetchOrderDetails(orderKeys);
          console.log('Air mode - selected orders with details:', selectedOrders.map(o => ({
            id: o.id,
            contact: o.contact,
            isHandCarry: o.isHandCarry,
            calculationMethod: o.calculationMethod
          })));
          
          const nonHandCarryOrders = selectedOrders.filter(order => !(order.isHandCarry === true));

          // Only flag handCarry orders that are missing types (non-handCarry handled above)
          const ordersWithoutType = selectedOrders.filter((order) => {
            if (!order.isHandCarry) return false;
            const airItems = order.handCarry?.airItems || [];
            if (airItems.length === 0) return true;
            return !airItems.some((ai) => ai.airItemTypeId && (ai.airItemType || ai.airItemTypeId));
          });

          if (nonHandCarryOrders.length > 0 || ordersWithoutType.length > 0) {
            handleOpenFixOrderDialog(nonHandCarryOrders, ordersWithoutType);
            return;
          }

          // Check if any order needs quantity input (per-item calculation)
          const ordersNeedingQuantity = selectedOrders.filter(order => 
            order.isHandCarry === true && order.calculationMethod === 'per_item'
          );

          if(ordersNeedingQuantity.length > 0) {
            const hasPerKgInMatch = selectedOrders.some(o => (o.handCarry?.airItems || []).some(ai => ai.airItemType?.calculationMethod === 'per_kg'));
            setPendingMatchData({
              weeklyShipKeys: weeklyShipKeys,
              orderKeys: orderKeys,
              shipDateId: shipDateId,
              hasPerKgInMatch
            });
            setOrdersNeedingQuantity(ordersNeedingQuantity);
            // Pre-fill per_kg weights from saved weightKg (audit) when present
            const initialPerKgWeights = {};
            ordersNeedingQuantity.forEach(o => {
              (o.handCarry?.airItems || []).forEach(ai => {
                if (ai.airItemType?.calculationMethod === 'per_kg' && ai.weightKg != null && ai.weightKg !== '') {
                  initialPerKgWeights[ai.id] = String(ai.weightKg);
                }
              });
            });
            setPerKgWeights(initialPerKgWeights);
            // Pre-fill: per-type when perItemAirItems, else single total per order (legacy)
            const initialQtys = {};
            ordersNeedingQuantity.forEach(o => {
              if (o.perItemAirItems?.length > 0) {
                o.perItemAirItems.forEach(ai => {
                  initialQtys[ai.id] = (ai.qty != null && ai.qty > 0) ? String(ai.qty) : '';
                });
              } else {
                initialQtys[o.id] = (o.assignedPerItemQty != null && o.assignedPerItemQty > 0)
                  ? String(o.assignedPerItemQty)
                  : '';
              }
            });
            setQuantities(initialQtys);
            setShowQuantityModal(true);
            return;
          }
        }

        // Proceed with normal matching if no quantity input needed
        const response = await matchWeeklyShipAndOrder({
          weeklyShipKeys: weeklyShipKeys,
          orderKeys: orderKeys,
          shipDateId: shipDateId
        })
        
        handleMatchingResponse(response, weeklyShipKeys, orderKeys);
      }else{
        toast.error('กรุณาเลือกข้อมูลในตารางขวา')
      }
    }else{
      toast.error('กรุณาเลือกข้อมูลในตารางซ้าย')
    }
  }

  const handleUnboxClick = async () => {
    if(weeklyShipKeys.length > 0){
      const response = await awaitUnboxWeeklyShip({weeklyShipKeys})
      if(response){
        toast.success("ดำเนินการเสร็จสิ้น")
        const updatedNodes = [];
        gridOptions.api.forEachNode(node => {
          if (weeklyShipKeys.includes(node.data.uuid)) {
            node.setData({...node.data, unBox: true});
            updatedNodes.push(node);
          }
        });
      }else(
        toast.error("มีบางอย่างผิดพลาด")
      )
    }else{
      toast.error("กรุณาเลือกรายการที่ต้องการยกเลิก")
    }
  }

  const handleCopyUnboxClick = async () => {
    let text = `รบกวนแกะเช็ค รอบเรือ ${shipDate} ด้วยค่ะ\n\n`
    const filteredData = rowData.filter(item => item.unBox === true);
    filteredData.forEach(item => {
      text += `ชื่อกล่อง: ${item.boxName}\n`; // Append each box number with label on a new line
      text += `เลขกล่อง: ${item.boxNo}\n`; // Append each box number with label on a new line
      text += `----\n`; // Append each box number with label on a new line
    });
    try{
      await navigator.clipboard.writeText(text);
      toast.success("Copied!!")
    }catch(e){
      toast.error("Failed")
    }
    
  }

  const handleCancelClick = async () => {
    if(weeklyShipKeys.length > 0){
      const response = await cancelWeeklyShipOrderMatch({weeklyShipKeys})
      if(response){
        toast.success("ดำเนินการเสร็จสิ้น")
        // Reflect the cancellation in the grid (boxes are back to unmatched).
        gridOptions.api.forEachNode(node => {
          if (weeklyShipKeys.includes(node.data.uuid)) {
            node.setData({...node.data, hasOrders: false});
          }
        });
      }else{
        toast.error("มีบางอย่างผิดพลาด")
      }
    }else{
      toast.error("กรุณาเลือกรายการที่ต้องการยกเลิก")
    }
  }

  const openModal = (src) => {
    setModalImageSrc(src);
    setShowModal(true);
  };
  

  const closeModal = () => {
    setShowModal(false);
    setModalImageSrc('');
  };

  useEffect(() => {
    getCustomerProfiles();
  }, []);

  useEffect(() => {
    setRowData(shipDates)
  }, [shipDates]);
  
  useEffect(() => {
    if(weeklyShipRowIndexes){
      gridRef.current.api.ensureIndexVisible(weeklyShipRowIndexes, 'middle');
    }
  },[rowData])

  useEffect(() => {
    if(profileRowIndex){
      gridRef2.current.api.ensureIndexVisible(profileRowIndex, 'middle');
    }
  },[rowData2])

  useEffect(() => {
    if(shipDateId)
      getUnmatchItemByShipDate(shipDateId);
  }, [shipDateId]);

  useEffect(() => {
    const formattedOrders = orders.map(order => ({
    ...order, // spread the other properties of the order
    orderDate: formatDate(order.orderDate), // overwrite orderDate with the formatted version
    shipDate : order.ShipDate ? formatDate(order.ShipDate.shipDate) : "",
  }));
    setRowData2(formattedOrders)
  }, [orders, selectedShipDate]);

  const filteredRowData = useMemo(() => {
    return showHighlightedRows
      ? rowData.filter((row) => !row.hasOrders)
      : rowData;
  }, [rowData, showHighlightedRows]);

  const notApprovedStyle = { backgroundColor: '#fecaca' }; // red-200

  const getOrderGridRowStyle = (params) => {
    if (params.data?.mercariVerifyStatus === 'not_approved') return notApprovedStyle;
    const id = params.data?.shipDateId
    if (id != null && id !== '') return hightlightMatchStyle
    return {}
  }

  return (
    <div className="ag-theme-alpine h-full" style={{ width: '100%' }}>
      <h2>Weekly Ship Match</h2>
      {showModal && <ImageModal src={modalImageSrc} onClose={closeModal} />}
      {heldModalOpen && (
        <HeldItemsModal
          shipDates={heldShipDates}
          profiles={heldProfiles}
          profilesReady={heldProfilesReady}
          deferPrint
          onClose={() => setHeldModalOpen(false)}
        />
      )}
      <div className='grid grid-cols-5 gap-x-10'>
        <div className='col-span-3'>
          <div className='flex justify-between'>
            <div className='flex'>
            <ShipDateDropdown 
              handleDataChange={handleSelectChange}
              includeDefault={true}
            />
            <button
              onClick={handleToggleHighlight}
              className="btn-primary text-white px-3 py-0.5 ml-3 rounded-md text-xl"
            >
              {showHighlightedRows ? 'แสดงทั้งหมด' : 'แสดงรายการที่เหลือ'}
            </button>
            <button
              onClick={openHeldModal}
              className="px-3 py-0.5 ml-3 bg-white border border-amber-300 hover:border-amber-500 text-amber-700 rounded-md text-xl"
            >
              ของที่พักไว้
            </button>
            </div>
            <div>
              <button className='btn-primary text-xl mr-2' onClick={handleCopyUnboxClick}>Copy Unbox</button>
              <button className='btn-primary text-xl mr-2' onClick={handleUnboxClick}>Unbox</button>
              <button className='btn-danger text-xl mr-2' onClick={handleCancelClick}>Cancel</button>
              <button className='btn-success text-xl' onClick={handleMatchClick}>Match</button>
            </div>
          </div>
          {isLoading && <CircularProgress />} {/* Render spinner when loading */}
          <div style={{ height: '80vh', marginTop: '10px' }}>
            <AgGridReact
              ref={gridRef}
              columnDefs={columnDefs}
              rowData={filteredRowData}
              defaultColDef={{ resizable: true, sortable: true }}
              getRowId={(params) => params.data.uuid}
              onSelectionChanged={handleWeeklyShipSelection}
              frameworkComponents={{ imageRenderer: ImageRenderer }}
              getRowHeight={(params) => {
                if (params.node.data.shipImageUrl) { // Or any other condition to identify rows with images
                    return 80;  // Height for rows with images
                }
                return 50;  // Default height for rows without images
              }}
              enableCellTextSelection={true}
              suppressRowVirtualisation={true}
              suppressColumnVirtualisation={true}
              gridOptions={gridOptions}
              getRowStyle={(params) => (params.data.hasOrders ? hightlightMatchStyle : (params.data.unBox ? highlightedUnboxStyle : {}))}
            />
          </div>
        </div>
        <div className='col-span-2'>
          <form onSubmit={handleFormSubmit} className='mb-2 ml-auto'>
            <TextField size="small" sx={{ mr: 1 }} id="outlined-search" label="เลขพัสดุญี่ปุ่น" type="search" onChange={handleInputChange} value={searchText}/>
            <IconButton type='submit' style={{ backgroundColor: 'green', borderRadius: '50%' }}>
              <SearchIcon fontSize="medium" style={{ color: 'white' }}/>
            </IconButton>
          </form>
          <div className='flex items-end'>
            <div className='w-80'>
              <ProfileCombo
                profiles={profiles} 
                onChange={handleProfileSelect} 
              />
            </div>
            <Button
              variant="contained"
              startIcon={<PersonIcon />}
              onClick={handleOpenCustomerProfile}
              disabled={!selectedProfile}
              sx={{ 
                ml: 2, 
                height: '40px',
                backgroundColor: selectedProfile ? '#1976d2' : '#ccc',
                '&:hover': {
                  backgroundColor: selectedProfile ? '#1565c0' : '#ccc'
                }
              }}
            >
              เปิดโปรไฟล์
            </Button>
            <div className='w-60 ml-4 mt-5'>
              <FormControlLabel control={
                <Checkbox
                checked={allOrder}
                onChange={toggleAllOrder}
                />
              } 
              label="ดูข้อมูลทั้งหมด" 
              />
            </div>
          </div>
          <div style={{ height: '80vh', marginTop: '10px' }}>
          <AgGridReact
            ref={gridRef2}
            columnDefs={columnDefs2}
            rowData={rowData2}
            defaultColDef={{ resizable: true, sortable: true }}
            getRowId={(params) => params.data.uuid}
            onSelectionChanged={handleOrderSelection}
            frameworkComponents={{ imageRenderer: ImageRenderer }}
            getRowHeight={(params) => {
              return 50;  // Default height for rows without images
            }}
            gridOptions={gridOptions2}
            enableCellTextSelection={true}
            suppressRowVirtualisation={true}
            suppressColumnVirtualisation={true}
            getRowStyle={getOrderGridRowStyle}
          />
          </div>
        </div>
      </div>

      {/* Combined Fix-Order Dialog: register handCarry + assign air item type in one pass */}
      <Dialog open={showFixOrderDialog} onClose={handleCloseFixOrderDialog} maxWidth="md" fullWidth>
        <DialogTitle>แก้ไขรายการก่อนจับคู่</DialogTitle>
        <DialogContent>
          {fixOrderItems.length === 0 ? (
            <div className="text-green-600 text-center py-6 text-base font-medium">
              ✓ แก้ไขครบแล้ว — กรุณาคลิก Match อีกครั้ง
            </div>
          ) : (
            <div className="space-y-4 mt-2">
              <p className="text-sm text-gray-600">
                รายการต่อไปนี้ยังไม่พร้อมจับคู่ กรุณาเลือกประเภทสินค้าและบันทึก
              </p>
              {fixOrderItems.map(order => (
                <div key={order.id} className="border-2 border-gray-200 rounded-lg p-3">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="font-medium text-sm">{order.contact || order.smileNameInput}</span>
                    {order.needsHandCarry && (
                      <span className="text-xs px-2 py-0.5 rounded-full bg-orange-100 text-orange-700 font-medium">
                        ยังไม่ได้ลงทะเบียนหิ้ว
                      </span>
                    )}
                  </div>
                  <a
                    href={order.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 text-xs hover:underline mb-3 block"
                  >
                    {order.url}
                  </a>
                  <div className="space-y-2">
                    {(airTypeAssignments[order.id] || []).map((row, idx) => {
                      const type = airItemTypesList.find(t => t.id === row.airItemTypeId)
                      const isPerItem = type?.calculationMethod === 'per_item'
                      return (
                        <div key={idx} className="flex items-end gap-2">
                          <div className="flex-1 min-w-0">
                            <AirItemTypeTripleDropdown
                              list={airItemTypesList}
                              value={row.airItemTypeId}
                              onChange={(id) => handleAirTypeAssignmentChange(order.id, idx, 'airItemTypeId', id)}
                              placeholder="เลือกประเภทสินค้าหิ้ว"
                              buttonClassName="w-full flex items-center justify-between rounded border border-gray-300 bg-white px-3 py-2 text-left text-sm"
                            />
                          </div>
                          {isPerItem && (
                            <div className="w-16 shrink-0">
                              <label className="block text-xs text-gray-500 mb-0.5">จำนวน</label>
                              <input
                                type="number"
                                min="1"
                                value={row.qty}
                                onChange={(e) => handleAirTypeAssignmentChange(order.id, idx, 'qty', parseInt(e.target.value) || 1)}
                                className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm"
                              />
                            </div>
                          )}
                          <button
                            type="button"
                            onClick={() => handleRemoveAirTypeRow(order.id, idx)}
                            className="p-1.5 text-red-500 hover:bg-red-50 rounded shrink-0"
                            disabled={(airTypeAssignments[order.id] || []).length <= 1}
                          >
                            <TrashIcon className="h-4 w-4" />
                          </button>
                        </div>
                      )
                    })}
                  </div>
                  <div className="flex justify-between items-center mt-3 pt-2 border-t">
                    <button
                      type="button"
                      onClick={() => handleAddAirTypeRow(order.id)}
                      className="flex items-center gap-1 text-sm text-indigo-600 hover:text-indigo-800"
                    >
                      <PlusIcon className="h-4 w-4" />
                      เพิ่มประเภท
                    </button>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleSaveFixOrder(order)}
                      disabled={savingFixOrderId === order.id}
                    >
                      {savingFixOrderId === order.id
                        ? <CircularProgress size={16} sx={{ color: 'white' }} />
                        : order.needsHandCarry ? 'ลงทะเบียน + บันทึก' : 'บันทึก'}
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </DialogContent>
        <DialogActions className="px-4 pb-3">
          <Button onClick={handleCloseFixOrderDialog}>ปิด</Button>
        </DialogActions>
      </Dialog>

      {/* Quantity / Weight Modal — all types per order: per_item = qty, per_kg = weight (kg) */}
      <Dialog open={showQuantityModal} onClose={handleQuantityModalClose} maxWidth="sm" fullWidth>
        <DialogTitle className="pb-1">
          จำนวนและน้ำหนัก — มี {ordersNeedingQuantity.length} รายการในกล่อง
        </DialogTitle>
        <DialogContent className="pt-2">
          <div className="space-y-4">
            {ordersNeedingQuantity.map((order, index) => {
              const allAirItems = order.handCarry?.airItems || [];
              const itemsWithValues = allAirItems.map((ai) => ({
                id: ai.id,
                airItemType: ai.airItemType,
                weightKg: perKgWeights[ai.id] ?? '',
                qty: quantities[ai.id] ?? '',
              }));
              return (
              <div key={order.id} className="rounded-lg border-2 border-gray-200 bg-gray-50/50 p-3">
                <div className="flex items-center gap-2 mb-2">
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-indigo-600 text-white text-sm font-bold">
                    {index + 1}
                  </span>
                  <span className="font-semibold text-gray-900">รายการที่ {index + 1}</span>
                </div>
                <div className="text-sm text-gray-700 mb-1">{order.contact}</div>
                <a
                  href={order.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800 hover:underline font-medium mb-3"
                >
                  <span>เปิดลิงก์สินค้า</span>
                  <span className="text-xs text-gray-500 truncate max-w-[200px]" title={order.url}>({order.url ? `${order.url.replace(/^https?:\/\//, '').slice(0, 50)}${order.url.length > 50 ? '…' : ''}` : ''})</span>
                </a>
                {allAirItems.length > 0 && (
                  <AirItemTypeInputs
                    items={itemsWithValues}
                    onWeightChange={handlePerKgWeightChange}
                    onQtyChange={handleQuantityChange}
                  />
                )}
              </div>
            );})}
          </div>
        </DialogContent>
        <DialogActions className="px-4 pb-3 pt-0">
          <Button onClick={handleQuantityModalClose}>ยกเลิก</Button>
          <Button onClick={handleQuantitySubmit} variant="contained">ยืนยัน</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default WeeklyShipMatch;
